import PropType from "prop-types";
import loaderGif from '../../../assets/icons/OneOpsNewLogo.gif'
import config from "../../../config/config";
import { useCentralStore } from "../../../store/appContext";
const Spinner = ({ showOverlay, ...rest }) => {
  return showOverlay ? (
    <div
      className={`fixed w-full h-full bg-black bg-opacity-25 z-30 flex backdrop-blur-sm`}
      onScroll={undefined}
    >
      <SpinnerLoader {...rest} />
    </div>
  ) : (
    <SpinnerLoader {...rest} />
  );
};

export const SpinnerLoader = ({
  loadingText,
  margin
}) => {

  const [{ carrierThemeData }] = useCentralStore();
  const { theme } = carrierThemeData;

  const spinnerFontStyle = {
    '--bg-color1': theme?.colors?.loaderColor1,
    '--bg-color2': theme?.colors?.loaderColor2,
  };

  return (
    <>
      <div className={`m-auto z-20 center w-56 h-56 ${margin}`}>
          <div class="wave" style={spinnerFontStyle}></div>
          <div class="wave" style={spinnerFontStyle}></div>
          <div class="wave" style={spinnerFontStyle}></div>
          <div class="wave" style={spinnerFontStyle}></div>
          <div class="wave" style={spinnerFontStyle}></div>
          <div class="wave" style={spinnerFontStyle}></div>
          <div class="wave" style={spinnerFontStyle}></div>
          <div class="wave" style={spinnerFontStyle}></div>
          <div class="wave" style={spinnerFontStyle}></div>
          <div class="wave" style={spinnerFontStyle}></div>
      </div>
      <div className="spinner-text">{loadingText}</div>
    </>
  );
};

SpinnerLoader.propTypes = {
  height: PropType.string,
  width: PropType.string,
  primaryColor: PropType.string,
  secondaryColor: PropType.string,
  backdropColor: PropType.string,
};

SpinnerLoader.defaultProps = {
  height: "h-14",
  width: "w-14",
  primaryColor: "border-t-primary",
  secondaryColor: "border-white",
  borderThickness: "border-4",
};

Spinner.propTypes = {
  showOverlay: PropType.bool,
  height: PropType.string,
  width: PropType.string,
  primaryColor: PropType.string,
  secondaryColor: PropType.string,
  backdropColor: PropType.string,
};

Spinner.defaultProps = {
  showOverlay: false,
  height: "h-14",
  width: "w-14",
  primaryColor: "border-t-white",
  secondaryColor: "border-app-border",
  borderThickness: "border-4",
};

export default Spinner;
